import { render } from "./k-field-group.vue?vue&type=template&id=5bdaf432"
import script from "./k-field-group.vue?vue&type=script&lang=js"
export * from "./k-field-group.vue?vue&type=script&lang=js"

import "./k-field-group.vue?vue&type=style&index=0&id=5bdaf432&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__